import * as CryptoJS from 'crypto-js';
const passkey = 'SeCrET:KeY:Knock:'.toString().padEnd(32, ' ');

export const encryptURLString = (value: string) => {
  return encodeURIComponent(
    CryptoJS.AES.encrypt(value, passkey, {
      iv: CryptoJS.enc.Utf8.parse(''),
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    }).toString(),
  );
};

export const decryptURLString = (value: string) => {
  return CryptoJS.AES.decrypt(decodeURIComponent(value), passkey, {
    iv: CryptoJS.enc.Utf8.parse(''),
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  }).toString(CryptoJS.enc.Utf8);
};


